<template>
  <div>
    <!-- "More" slide-out drawer -->
    <v-navigation-drawer v-model="drawerOpen" temporary>
      <v-list>
        <v-list-item prepend-icon="mdi-view-dashboard-outline" title="dashboard" to="/dashboard" @click="closeDrawer"></v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list subheader>
        <v-list-subheader>assets</v-list-subheader>
        <v-list-item prepend-icon="mdi-home-city-outline" title="properties" to="/properties" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-car-outline" title="vehicles" to="/vehicles" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-diamond-stone" title="collectibles" to="/collectibles" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-cash-multiple" title="cash" to="/cash" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-bank" title="loans" to="/loans" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-apps" title="securities" to="/securitiessummary" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-book-settings-outline" title="super funds" to="/superfunds" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-package-variant-closed" title="other" to="/otherassets" @click="closeDrawer"></v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list subheader>
        <v-list-subheader>income & expenses</v-list-subheader>
        <v-list-item prepend-icon="mdi-account-cash-outline" title="salaries" to="/salaries" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-credit-card-fast-outline" title="expenses" to="/expenses" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-invoice-text-check-outline" title="banking" to="/bankaccountsummary" @click="closeDrawer"></v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list subheader>
        <v-list-subheader>categories</v-list-subheader>
        <v-list-item prepend-icon="mdi-code-block-brackets" title="security categories" to="/securitycategories" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-chart-donut" title="portfolio allocation" to="/portfolioallocation" @click="closeDrawer"></v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list subheader>
        <v-list-subheader>activity</v-list-subheader>
        <v-list-item prepend-icon="mdi-eye-outline" title="watchlist" to="/watchlist" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-bell-outline" title="notifications" to="/notifications" @click="closeDrawer"></v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list subheader>
        <v-list-subheader>reports</v-list-subheader>
        <v-list-item prepend-icon="mdi-chart-timeline-variant" title="modelling" to="/modelling" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-camera-outline" title="portfolio snapshot" to="/reports" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-scale-balance" title="cgt disposals" to="/reports/cgt-disposals" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-cart-outline" title="acquisitions" to="/reports/acquisitions" @click="closeDrawer"></v-list-item>
        <v-list-item prepend-icon="mdi-trending-up" title="performance" to="/reports/investment-performance" @click="closeDrawer"></v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list>
        <v-list-item prepend-icon="mdi-cog-outline" title="admin" to="/admin" @click="closeDrawer"></v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Bottom navigation bar -->
    <v-bottom-navigation :model-value="activeTab" grow elevation="8" class="mobile-bottom-nav">
      <v-btn value="dashboard" to="/dashboard">
        <v-icon>mdi-view-dashboard-outline</v-icon>
        <span>dashboard</span>
      </v-btn>
      <v-btn value="securities" to="/securitiessummary">
        <v-icon>mdi-apps</v-icon>
        <span>securities</span>
      </v-btn>
      <v-btn value="portfolioallocation" to="/portfolioallocation">
        <v-icon>mdi-chart-donut</v-icon>
        <span>allocation</span>
      </v-btn>
      <v-btn value="more" @click.prevent="toggleDrawer">
        <v-icon>mdi-menu</v-icon>
        <span>more</span>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: 'MobileNav',
  data() {
    return {
      drawerOpen: false
    }
  },
  computed: {
    activeTab() {
      const path = this.$route.path
      if (path === '/dashboard') return 'dashboard'
      if (path === '/securitiessummary' || path.startsWith('/brokeraccounts')) return 'securities'
      if (path === '/portfolioallocation') return 'portfolioallocation'
      return 'more'
    }
  },
  methods: {
    toggleDrawer() {
      this.drawerOpen = !this.drawerOpen
    },
    closeDrawer() {
      this.drawerOpen = false
    }
  }
}
</script>

<style scoped>
.mobile-bottom-nav {
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
